<template>
  <div class="easy-to-use-cont center">
    <div class="name">손쉽게 사용하기</div>
    <div class="mt20">그동안 url을 직접 입력하시느라 힘드셨죠?</div>
    <div><b>꿀팁</b>입니다!!!</div>
    <div>모바일에서 좀더 쉽게 사용하는 방법을 추천드릴게요!!</div>

    <div class="iphone-form center mt28" v-if="isIphone">
      <div class="button" @click="type = 'android'">혹시 안드로이드 폰이신가요?</div>
      <div class="mt20">아이폰은 먼저 사파리를 키셔야 합니다.</div>
      <div class="mt20">1. 사진 처럼 공유하기 버튼을 눌러주세요.</div>
      <img class="img" src="@/assets/img/easy-to-use/iphone-1.jpeg">
      <div class="mt20">2. 홈화면에 추가 버튼을 눌러주시면 됩니다.</div>
      <img class="img" src="@/assets/img/easy-to-use/iphone-2.jpeg">
      <div class="mt20">3. 원하시는 이름을 입력하시고<br> 오른쪽 위의 추가 버튼을 눌러주세요.</div>
      <img class="img" src="@/assets/img/easy-to-use/iphone-3.jpeg">
      <div class="mt20">4. 짜잔!! 이제 앱처럼 이용할 수 있습니다.</div>
      <img class="img" src="@/assets/img/easy-to-use/iphone-4.jpeg">
    </div>

    <div class="android-form center mt28" v-else>
      <div class="button" @click="type = 'iphone'">혹시 아이폰이신가요?</div>
      <div class="mt20">제가 아이폰 사용자라 스크린 샷이 없어요ㅠㅠㅠ</div>
      <div>글로 설명해 드릴게요!</div>
      <div>아니면 "안드로이드 웹페이지 홈화면 추가"라고</div>
      <div>검색하시면 많은 블로그들이 나옵니다.</div>
      <div>크롬, 네이버앱, 삼성등등</div>
      <div>브라우저 개발사에 따라 방법이 조금 다르지만</div>
      <div>그래도 다 비슷비슷합니다~~</div>
      <div class="mt20">1. 즐겨 사용하는 브라우저를 킵니다.</div>
      <div>2. 홈 화면에 추가할 페이지로 이동합니다.</div>
      <div>3. 메뉴 버튼을 누르고 '홈화면에 추가'버튼을 누릅니다.</div>
      <div>4. 저장할 이름을 입력합니다.</div>
      <div>5. 짜잔!! 그럼 앱처럼 사용할 수 있습니다.</div>
      <a href="https://nuknukhan.tistory.com/45">참고 사이트</a>
      <div>혹시 잘 안되시는 분은 위 링크를 참고해주세요.</div>
    </div>

    <div class="mt28">헿.. <b>꿀팁</b>이라고 하기엔 좀 부실하죠?</div>
    <div><b>죄송...</b></div>
    <div>다음 업데이트엔 더 좋은 기능을 개발할게요..</div>
    <div><b>그럼 영화 재밌게 보세요~~</b></div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        type: 'iphone'
      }
    },
    computed: {
      isIphone () {
        return this.type === 'iphone';
      }
    },
  }
</script>

<style lang="scss" scoped>
.easy-to-use-cont {
  padding: 30px 0 50px 0;
  font-size: 16px;
  color: #333333;
  line-height: 1.7;
  text-align: center;

  .name {
    font-size: 24px;
    font-weight: bold;
  }
  .img {
    width: 200px;
    margin-top: 8px;
  }
  .button {
    color: #1976d2;
    user-select: none;
    cursor: pointer;
    border-bottom: 1px solid #1976d2;
  }
}
.mt12 {
  margin-top: 12px;
}
.mt20 {
  margin-top: 20px;
}
.mt28 {
  margin-top: 28px;
}
.center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
